var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrandGAds(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.4629 27.2928C51.1636 22.5765 49.5609 16.5457 44.8832 13.8227C40.2054 11.0998 34.224 12.7157 31.5233 17.432L11.3272 52.7014C8.62654 57.4178 10.2293 63.4486 14.907 66.1715C19.5847 68.8945 25.5661 67.2786 28.2668 62.5622L48.4629 27.2928Z",
    fill: "#F8BB2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5656 57.6365C29.5656 63.084 25.1857 67.5 19.7828 67.5C14.3799 67.5 10 63.084 10 57.6365C10 52.189 14.3799 47.7729 19.7828 47.7729C25.1857 47.7729 29.5656 52.189 29.5656 57.6365Z",
    fill: "#3BA757"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5525 27.2928C28.8518 22.5765 30.4545 16.5457 35.1322 13.8227C39.8099 11.0998 45.7913 12.7157 48.492 17.432L68.6881 52.7014C71.3888 57.4178 69.7861 63.4486 65.1084 66.1715C60.4306 68.8945 54.4492 67.2786 51.7485 62.5622L31.5525 27.2928Z",
    fill: "#4689F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandGAds);
export default __webpack_public_path__ + "static/media/Brand-G-Ads.0b9809c8bde971698c3cf73669232a31.svg";
export { ForwardRef as ReactComponent };